"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const userDirectoryTranslations = {
    directory: "Directory",
    searchPlaceholder: "Search by name, phone, or @email",
    headerTitle: "All Users",
    filteredHeaderTitle: "Filtered Users",
    toDate: "To Date",
    filter: {
        title: "Filter",
        userType: "Filter by user type",
        userRole: "Filter by role",
    },
    status: "Status",
    reset: "Reset",
    sNo: "No.",
    all: "All",
    completed: "COMPLETED",
    failed: "FAILED",
    inProgress: "IN PROGRESS",
    success: "We will notify you when files are ready for download",
    headerMembersTitle: "Members",
    userTypes: {
        clinician: "Clinician",
        staff: "Staff",
        patient: "Patient",
        physician: "Physician",
        admin: "Admin",
    },
};
exports.default = userDirectoryTranslations;
